import { AnimationState } from "@/features/iris/contracts/iris.contracts";
import { ANIMATIONS } from "@/features/iris/static/iris.static";
import Modal from "@/ui/Modal2";
import { Body } from "@/ui/typography/Body";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { useTranslation } from "next-i18next";

type IrisProgressModalProps = {
  open?: boolean;
  state: AnimationState;
  stateText: string;
  onClose?: () => void;
};

export const IrisProgressModal = ({
  open,
  state,
  stateText,
  onClose,
}: IrisProgressModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      showClose={state === "error"}
      className="max-w-56 space-y-0 [&>h2]:-mb-4"
      onClose={onClose}
    >
      <div className="pointer-events-none flex flex-col items-center justify-center space-y-4">
        <DotLottieReact
          src="/ai_assistant_animations.lottie"
          loop={state === "busy"}
          autoplay
          segment={ANIMATIONS[state].segment}
          className="size-10"
        />
        <Body className="text-center">{t(stateText)}</Body>
      </div>
    </Modal>
  );
};
